import React from 'react'
import {findDOMNode} from "react-dom"

import PopoverComponent, {PopoverComponentProps, PopoverComponentState} from "../../../../gd-components/base-component/popover-component"
import Popover from "../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../gd-components/gd-popover/@const"
import TextEditPopoverForm from "../../../system/components/text-edit/text-edit-popover-form"

type Props = PopoverComponentProps & {
    value              : any
    className?         : string
    canEdit?           : boolean
    onChange?          : callback

    attachment?        : string
    targetAttachment?  : string
    targetOffset?      : string
    attachmentType?    : PopoverAttachmentType | 'full'| 'vertical'| 'horizontal'
}

type State = PopoverComponentState

export default class StringInListWithPopover extends PopoverComponent<Props, State> {

    onSave = (value:any) => {
        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false)
            if (this.props.onChange) this.props.onChange(value)
        })
    }

    renderPopover() {
        if (this.state.showPopover) {
            const popoverPosition = new PopoverPosition({
                attachment      : this.props.attachment ? this.props.attachment : 'top center', //defaultProps somehow doesn't work
                targetAttachment: this.props.targetAttachment ? this.props.targetAttachment : 'bottom center',
                targetOffset    : this.props.targetOffset,
                attachmentType  : (this.props.attachmentType ? this.props.attachmentType : 'horizontal') as PopoverAttachmentType,
            })

            return (
                <Popover popoverClass="gd-field-text-edit-popover"
                         className="gd-field-text-edit-popover-container"
                         position={popoverPosition}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>

                    <TextEditPopoverForm text={this.props.value} onSave={this.onSave}/>

                </Popover>
            )
        }
    }

    render() {
        const classes = Classes('gd-field-text','list', 'ui5-field-input-hover-border')

        return (
            <div className={classes} onClick={this.props.canEdit === false ? null : this.togglePopover}>
                {this.props.value}
                {this.renderPopover()}
            </div>
        )
    }
}
